import { FormInstance } from 'antd';

export interface TaxpayerInterface {
    taxpayerType: string;
    name: {
        nameRu?: string;
        nameKk?: string;
        nameQq?: string;
        nameEn?: string;
    };
    lzchpRegType?: string;
}

export interface FileUploadItemProps {
    name: FileTypes;
    form: FormInstance;
    required?: boolean;
    totalFiles?: number;
    totalFileSize?: number;
}

export enum FileTypes {
    ACT = 'courtActs',
    COUNTERPARTY = 'counterpartyLists',
    CONFIRMATION = 'confirmationDocuments',
    DELETION = 'deletionFiles',
}

export interface DeletionFormValues {
    id: number;
    cause: string;
    [FileTypes.DELETION]: File[];
}

export interface FileData {
    fileId: number;
    fileName: string;
    fileContentType: string;
    fileSize: number;
    fileContent: null;
}

export interface FalseDeal {
    id: number;
    iinBin: string;
    fullName: string;
    actNumber: string;
    preparationDate: string;
    createdDate: string;
    lastModifiedDate: string;
    createdBy: string;
    modifiedBy: string;
    courtActs: FileData[];
    counterpartyLists: FileData[];
    confirmationDocuments: FileData[];
    deleted: boolean;
    deletionCause: string;
    deletionFile: FileData[];
}

export interface SearchFormValues {
    iinBin: string;
    fullName: string;
    actNumber: string;
    preparationDateFrom: string;
    preparationDateTo: string;
    createdDateFrom: string;
    createdDateTo: string;
}

export namespace FalseDealsAdmin {
    export interface Props {
        commonTranslations: Record<string, any>;
        token: string;
        config: Record<string, any>;
        translations: Record<string, any>;
        language: string;
        roles: string[];
        privileges: string[];
    }
}
